export const PWA_INSTALL_DISMISSAL_STORAGE_KEY = "garimpa.pwa-install.dismissed-until.v1";
export const PWA_INSTALL_DISMISSAL_MS = 30 * 24 * 60 * 60 * 1000;
